import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { GridstackComponent, NgGridStackOptions } from 'gridstack/dist/angular';
import { Subject } from 'rxjs';
import { ChartWidgetComponent } from '../chart-widget/chart-widget.component';
import { ChartLabelComponent } from '../chart-label/chart-label.component';
import { ChartTableComponent } from '../chart-table/chart-table.component';
import { DashboardBuilderVarService } from '../dashboard-builder-service/dashboard-builder-var.service';
import { CdkOverlyayService } from 'src/app/shared/custom-overlay/cdk-overlyay.service';
import { TemplateDropdownComponent } from 'src/app/shared/custom-overlay/template-dropdown/template-dropdown.component';
import { SharedService } from 'src/app/services/shared.service';
import { DashboardBuilderService } from '../dashboard-builder-service/dashboard-builder.service';
import { takeUntil } from 'rxjs/operators';
import { GridStackOptions } from 'gridstack';
import { WidgetBuilderVarService } from '../widget-builder-service/widget-builder-var.service';
import { TimeZoneService } from 'src/app/services/time-zone.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { FormGroup, UntypedFormBuilder, UntypedFormControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ChangeDetectorRef } from '@angular/core';
import { RoutecrumpsService } from 'src/app/services/routecrumps.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dashboard-preview',
  templateUrl: './dashboard-preview.component.html',
  styleUrls: ['./dashboard-preview.component.scss']
})
export class DashboardPreviewComponent {

  @Input() data:any;
  @Input() dbname:string="";
  @Input() overviewMode=false
  @Output() closePreview:EventEmitter<boolean> = new EventEmitter();
  @ViewChild(GridstackComponent) gridComp?: GridstackComponent;
  @ViewChild('child') child?: ElementRef;
  private destroy$: Subject<void> = new Subject<void>();  
  selectedColorIndex:number = 10;
  previewRef:any;
  moreoptiontitles = this.sharedService.metaData.dashboard.dashboard_landing.widgetmenu
  widget_lists:any = []

  constructor(
    public dashboardBuilderVarService: DashboardBuilderVarService,
    private dashboardBuilderService: DashboardBuilderService,
    private cdkverlayDialog: CdkOverlyayService,
    public sharedService:SharedService,
    private widgetBuilderVarService:WidgetBuilderVarService,
    private timeZoneService:TimeZoneService,
    private dashboardService:DashboardService,
    private fb: UntypedFormBuilder,
    private cdf : ChangeDetectorRef,
    private rcrumpService: RoutecrumpsService,
    private router : Router
  ){

  }

  widgetGridOptions: NgGridStackOptions = {}
  gridChildren:any = []

  maxdate = this.timeZoneService.getcurrentuserTime().format('YYYY-MM-DD')
  mindate = this.timeZoneService.toUserTimeZone(this.sharedService.timeRange.event_time_range[0]).format('YYYY-MM-DD');
  
  defaultTimeRange = {
    from: this.timeZoneService.getcurrentuserTime().clone().startOf('D').format('YYYY-MM-DD'),
    to: this.timeZoneService.getcurrentuserTime().format('YYYY-MM-DD')
  }


  timeRange = this.fb.group({
    fromDate: new UntypedFormControl(this.defaultTimeRange.from),
    toDate: new UntypedFormControl(this.defaultTimeRange.to),
  }, { validators: [this.creatDateRangeValidator()] });

  selectTime = this.fb.group({
    fromDate: new UntypedFormControl(this.defaultTimeRange.from),
    toDate: new UntypedFormControl(this.defaultTimeRange.to),
  }, { validators: [this.creatDateRangeValidator()] });

  subtitle:string = ""
  filterDays:any;

  dashboardMode:boolean = false

  ngOnInit(): void {
    const nav = history.state;

    

//console.log("NAV =---->",nav)

    if(Object.keys(nav).includes('data')){
      this.dashboardMode = true
      this.data = nav.data;
      this.dbname = nav.dbname;
      if(Object.keys(nav).includes('home')){
        this.createRouteCrump(this.dbname,true)
      }else{
        this.createRouteCrump(this.dbname)
      }
      
    }

    // console.log(this.data,"\n",this.dbname)

    


    this.widgetGridOptions=this.data
    this.gridChildren = this.data.children
    // console.log(this.gridChildren)
    GridstackComponent.selectorToType = {
      'app-chart-widget': ChartWidgetComponent,
      'app-chart-label':ChartLabelComponent,
      'app-chart-table':ChartTableComponent
    };

//console.log("DB =---->",this.dbname,this.data)

// console.log(this.gridChildren)

    // this.gridChildren = this.data.children
    this.gridChildren.forEach((child:any) => {
      // if(["label","table"].includes(child.input.data.type)) {
      //   child.selector = `app-chart-${child.input.data.type}`
      //   widget_lists.push({"widget_id":child.input.data.id,"platform_id":child.input.data.platform_id})
      // } else {
      //   child.selector = "app-chart-widget";
      //   widget_lists.push({"widget_id":child.input.data.id,"platform_id":child.input.data.platform_id})
        
      // }
      this.widget_lists.push({"widget_id":child.input.data.id,"platform_id":child.input.data.platform_id})
      child.input.mode = "builder"
      child.input.widgetId = child.input.data.id
      child.input.widgetdata = {}
    });
    this.widgetGridOptions.disableDrag = true;
    this.widgetGridOptions.disableResize = true;
    this.widgetGridOptions.children = []
    
    
    this.dashboardBuilderService.dashboardWidgetDataGet(this.buildWidgetReqobj(this.widget_lists,false,[]))
      .pipe(takeUntil(this.destroy$))
      .subscribe((dat:any)=>{
        if(dat.hasOwnProperty("isError") && dat["isError"]){
          this.gridChildren.forEach(child => {
            child.input.widgetdata = dat
            child.input.widgetdata.widgetdata = this.formatWidgetData(child.input.widgetdata.widgetdata)
          });
        } else {
          this.gridChildren.forEach(child => {
            child.input.widgetdata = dat[parseInt(child.input["widgetId"])]
            child.input.widgetdata.widgetdata = this.formatWidgetData(child.input.widgetdata.widgetdata)
          });
        }
    })

//console.log(this.data,"\n",this.dbname)

  }

  initElement(element: HTMLElement) {
    const observer = new ResizeObserver(entries => {
      const { width, height } = entries[0].contentRect;
  
// console.log('resized', height);
      this.onResize(width, height);
    });
  
    observer.observe(element);
  }

  onResize(width: number, height: number) {
// console.log('New Height =----> ', height);
    this.dashboardBuilderVarService.nestedGridOptions.cellHeight = this.child.nativeElement.clientHeight/10
    this.gridComp.grid?.cellHeight(this.child.nativeElement.clientHeight/10)
// console.log("Option =---->",this.dashboardBuilderVarService.nestedGridOptions)

    this.cdf.detectChanges()

  }


  ngAfterViewInit(): void {

// console.log("Before Changes =---->",JSON.parse(JSON.stringify(this.dashboardBuilderVarService.nestedGridOptions)))
    this.initElement(this.child.nativeElement)
// console.log(this.child.nativeElement.clientHeight)
    this.gridComp.grid.cellHeight(this.child.nativeElement.clientHeight/10)
    this.dashboardBuilderVarService.nestedGridOptions.cellHeight = this.child.nativeElement.clientHeight/10

  }

  createRouteCrump(disp,home?) {
    if(home){
      // console.log("From home")
      this.rcrumpService.route_crumps[1] = {
        disp_str: disp,
        routeTo: "dashboard-preview",
        callback: null,
        isParent: true
      };
      this.rcrumpService.route_crumps.length = 2;
    }
    else{
      // console.log("From Dashboard")
      this.rcrumpService.route_crumps[2] = {
        disp_str: disp,
        routeTo: "dashboard-preview",
        callback: null,
        isParent: false
      };
      this.rcrumpService.route_crumps.length = 3;
    }
   
  }

  creatDateRangeValidator(): ValidatorFn {
      return (form: FormGroup): ValidationErrors | null => {
        const err = {}
        const start = this.timeZoneService.setcurrentuserTime(form.get("fromDate").value);
        const end = this.timeZoneService.setcurrentuserTime(form.get("toDate").value);
  
        if (start && end) {
          const validyear = start.year() > 2000 && end.year() > 2000;
          if (!validyear) {
            err['yearrange'] = true;
          }
          const isRangeValid = (end.unix() - start.unix() >= 0) && (end || start) < this.timeZoneService.getcurrentuserTime();
  
          if (!isRangeValid) {
            err['dateRange'] = true;
          }
        }
        return err;
      }
    }

  buildWidgetReqobj(widget_lists,datefilter,timerange){
    return {
      "widgetlist":widget_lists,
      "time_range":timerange,
      "timezone":this.sharedService.timeZone,
      "date_filter":datefilter,
      "mode":this.dashboardBuilderVarService.dashboard_preview_mode
    }
    
  }

  getWidgetData(widget_id_list){
    return this.dashboardBuilderVarService.chartData
  }

  open_overlay(template:any, origin:any,){
    let config = {
      // width: '5%',
      // backdropClass: 'cdk-overlay-dark-backdrop',
      data: {

        "template": template,
      }
    }
    this.previewRef = this.cdkverlayDialog.openPreview(config, TemplateDropdownComponent, origin);

  
    this.previewRef.$closed.subscribe(() => {
      
    })
  }

  openOverlay_templateRef(template:any, origin:any, overlaytype:any):void {
    this.open_overlay(template,origin)
  }

  colorPalatte_click(selectedColor:string,index:number) {
//console.log("color palette clik===============",selectedColor,index)
    this.selectedColorIndex=index
    this.widgetBuilderVarService.previewColorpalette$.next(selectedColor)
  }



 setWidgetData(datefilter,timerange,mode){
    this.widgetBuilderVarService.previewProgress$.next(true)
    let reqobj = this.buildWidgetReqobj(this.widget_lists,datefilter,timerange)
    this.dashboardBuilderService.dashboardWidgetDataGet(reqobj)
      .pipe(takeUntil(this.destroy$))
      .subscribe((dat:any)=>{
       
        if(dat.hasOwnProperty("isError") && dat["isError"]){
          this.gridChildren.forEach(child => {
            child.input.widgetdata = dat
            child.input.widgetdata.widgetdata = this.formatWidgetData(child.input.widgetdata.widgetdata)
            this.cdf.detectChanges()
          });
        } else {
          if(mode == "refresh"){
            this.gridChildren.forEach(child => {
              this.setTimeRange(child.input.data.time_range)
              this.filterDays = child.input.data.time_range[2]
              this.customSubtitle(this.timeRange.controls.fromDate.value, this.timeRange.controls.toDate.value, this.filterDays)
              this.cdf.detectChanges()
              child.input.widgetdata = dat[parseInt(child.input["widgetId"])]  
              child.input.widgetdata.widgetdata = this.formatWidgetData(child.input.widgetdata.widgetdata)
            });

          } else {
            this.customSubtitle(this.timeRange.controls.fromDate.value, this.timeRange.controls.toDate.value, this.filterDays)
            this.cdf.detectChanges()
            this.gridChildren.forEach(child => {
              child.input.widgetdata = dat[parseInt(child.input["widgetId"])]  
              
              child.input.widgetdata.widgetdata = this.formatWidgetData(child.input.widgetdata.widgetdata)
             
            });
          }
        }
        
    })
//console.log("WidgetData =---->",this.gridChildren)
  }

  resetdateinput() {
    this.selectTime.controls.fromDate.reset(this.defaultTimeRange.from);
    this.selectTime.controls.toDate.reset(this.defaultTimeRange.to);
  }

  refreshWidget(){
    this.resetdateinput()
    this.setWidgetData(false,[],"refresh")
  }

  setTimeRange(noOfDays: any) {
    if (noOfDays && noOfDays[2] >= 0) {
      this.filterDays = noOfDays[2];
      this.timeRange.controls.fromDate.patchValue(this.sharedService.calculate_timerange(noOfDays)[0]);
      this.timeRange.controls.toDate.patchValue(this.sharedService.calculate_timerange(noOfDays)[1]);
    } else {
      this.filterDays = undefined;
      this.timeRange.controls.fromDate.patchValue(this.timeZoneService.setcurrentuserTime(this.selectTime.controls.fromDate.value).format('YYYY-MM-DD'));
      this.timeRange.controls.toDate.patchValue(this.timeZoneService.setcurrentuserTime(this.selectTime.controls.toDate.value).format('YYYY-MM-DD'));
    }
  }
  
    dateFilterClick(){
      if(!this.selectTime.errors){
      if(this.previewRef){
        this.previewRef.close()
      }
      this.setTimeRange("")
      let time_range = [this.timeZoneService.toUtcTimeZonefromUser(this.timeRange.controls.fromDate.value).format(this.dashboardService.timeformat), this.timeZoneService.toUtcTimeZonefromUser(this.timeRange.controls.toDate.value).format(this.dashboardService.timeformat)]
      this.setWidgetData(true,time_range,"custom")
    }
  }
  
  
  customSubtitle(fromdate, todate, numDays) {
    let sub = ""
    let format = 'D MMM'
    switch (true) {
      case (numDays == undefined || (fromdate && todate)):
        this.subtitle = sub + ` ` + `custom   ( ${this.timeZoneService.toUserTimeZone(fromdate).format(format)}  to  ${this.timeZoneService.toUserTimeZone(todate).format(format)} )`;
        break;
      case (numDays == 1):
        this.subtitle = sub + ` ` + ` yesterday` + `   ( ${this.timeZoneService.toUserTimeZone(fromdate).format(format)}  to  ${this.timeZoneService.toUserTimeZone(todate).format(format)} )`;
        break;
      case (numDays == 0):
        this.subtitle = sub + ` ` + ` today` + `   ( ${this.timeZoneService.toUserTimeZone(fromdate).format(format)}  to  ${this.timeZoneService.toUserTimeZone(todate).format(format)} )`;
        break;
      default:
        this.subtitle = sub + ` ` + ` past ${numDays + 1} days` + `   ( ${this.timeZoneService.toUserTimeZone(fromdate).format(format)}  to  ${this.timeZoneService.toUserTimeZone(todate).format(format)} )`;
    }
  }

  relativeTimeClick(mode:string,filtervalue:any,timemode:string){
    if (this.previewRef) {
      this.previewRef.close()
    }
//console.log("filtervalue===",filtervalue)
    this.setTimeRange(filtervalue)
    let timerange = this.sharedService.getTimerangeFromMetaDate(filtervalue)
    // let reqobj = this.buildWidgetReqobj(this.widget_lists,true,timerange)
    // console.log("buildWidgetReqobj===relativeTimeClick==",reqobj)
    // this.setWidgetData(true,timerange)
    this.setWidgetData(true,timerange,"relative")

    // this.dashboardBuilderService.dashboardWidgetDataGet(this.buildWidgetReqobj(this.widget_lists,true,timerange))
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe((dat:any)=>{
    //     this.gridChildren.forEach(child => {
    //       child.input.widgetdata = dat[parseInt(child.input["widgetId"])]
    //     });
    // })
  }

  formatWidgetData(widgetData: any) {
    if (!widgetData?.rows || !widgetData?.headers) {
      return widgetData;
    }
  
    // find all headers where disp === "Time"
    const timeHeaders = widgetData.headers
      .filter((h: any) =>  h.type?.toLowerCase() === 'timestamp')
      .map((h: any) => h.value);
  
    const formattedRows = widgetData.rows.map((row: any) => {
      const updatedRow = { ...row };
  
      timeHeaders.forEach((key: string) => {
        const value = updatedRow[key];
  
        // skip null/undefined
        if (value === null || value === undefined) return;
  
        const strValue = String(value);
  
        // if value is like 00,01,02... leave it as is
        const isHourFormat = /^\d{2}$/.test(strValue);
  
        if (!isHourFormat) {
          // treat as epoch
          const epoch = Number(value);
  
          if (!isNaN(epoch)) {
            const date = new Date(
              strValue.length === 10 ? epoch * 1000 : epoch
            );
  
            updatedRow[key] = date.toLocaleDateString('en-GB', {
              day: '2-digit',
              month: 'short'
            });
          }
        }
      });
  
      return updatedRow;
    });
  
    return {
      ...widgetData,
      rows: formattedRows
    };
  }
 

  closePreviewClick(){
    if(Object.keys(history.state).includes('home')){
      this.router.navigateByUrl('home')
    }
    else if(this.dashboardMode){
    this.router.navigateByUrl('dashboard')
    }else{
      this.closePreview.emit(true)
    }
    
  }


  ngOnDestroy(): void {
    this.dashboardBuilderVarService.dashboardMode = false
    this.dashboardMode = false
    this.destroy$.next()
    this.destroy$.complete()
  }

}
